module.exports = __webpack_public_path__ + "c7ef3609255d00e7b0f89b5d56c557b3.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/foundation/orbit/rotator-black.png
// module id = 177
// module chunks = 0